import PageHero from "@/components/layout/PageHero";
import Contact from "@/components/sections/Contact";
import FinalCTA from "@/components/sections/FinalCTA";

const Contato = () => (
  <>
    <PageHero
      eyebrow="Entre em contato"
      title="Fale Conosco"
      description="Telefone, WhatsApp ou e-mail — escolha o canal que preferir e fale direto com a nossa equipe."
    />
    <Contact showHeading={false} />
    <FinalCTA />
  </>
);

export default Contato;
